// src/services/userService.js
import { wOrgIdMiddleware } from '../utils/commonUtils';
import { OK } from '../utils/constant';
import http from './http';
// import { useDispatch } from 'react-redux';
// import {setProfileDetails} from '../store/ProfileSlice';


const UserService = {
  /**
   * Verify PIN for logged-in user. Returns signature if valid.
   * When activityId is provided, backend validates user's signed_authority against activity's required_authority.
   * @param {string} pin - User's PIN
   * @param {string} [activityId] - Optional activity ID for signed_authority validation
   * @returns {Promise<{success: boolean, signature: string}>}
   */
  verifyPin: async (pin, activityId = null) => {
    try {
      const payload = { pin };
      if (activityId) payload.activity_id = activityId;
      const response = await http.POST('verify-pin', payload);
      if (response?.code === 200 && response?.data) {
        return response.data;
      }
      const errData = response?.data || response;
      const err = new Error(errData?.message || "Invalid PIN");
      err.data = errData;
      err.errors = errData?.errors;
      throw err;
    } catch (error) {
      if (error?.response?.data) {
        const d = error.response.data;
        const err = new Error(d?.data?.message || d?.message || "Invalid PIN");
        err.data = d?.data || d;
        err.errors = d?.data?.errors || d?.errors;
        throw err;
      }
      throw error;
    }
  },

  /**
   * Set PIN + Signature for logged-in user.
   * @param {string} pin
   * @param {string} signature - base64 dataURL
   */
  setPinSignature: async (pin, signature) => {
    try {
      const payload = { pin, signature };
      const response = await http.POST("set-pin-signature", payload);
      if (response?.code === 200 && response?.data) {
        return response.data;
      }
      const errData = response?.data || response;
      const err = new Error(errData?.message || "Failed to save PIN & Signature");
      err.data = errData;
      err.errors = errData?.errors;
      throw err;
    } catch (error) {
      if (error?.response?.data) {
        const d = error.response.data;
        const err = new Error(d?.data?.message || d?.message || "Failed to save PIN & Signature");
        err.data = d?.data || d;
        err.errors = d?.data?.errors || d?.errors;
        throw err;
      }
      throw error;
    }
  },

  verifyKioskPin: async (pin) => {
    try {
      const response = await http.POST("verify-kiosk-pin", { pin });
      if (response?.code === 200 && response?.data) {
        return response.data;
      }
      const errData = response?.data || response;
      const err = new Error(errData?.message || "Invalid kiosk PIN");
      err.data = errData;
      throw err;
    } catch (error) {
      if (error?.response?.data) {
        const d = error.response.data;
        const err = new Error(d?.data?.message || d?.message || "Invalid kiosk PIN");
        err.data = d?.data || d;
        throw err;
      }
      throw error;
    }
  },

  setKioskPin: async (pin) => {
    try {
      const response = await http.POST("set-kiosk-pin", { pin });
      if (response?.code === 200 && response?.data) {
        return response.data;
      }
      const errData = response?.data || response;
      const err = new Error(errData?.message || "Failed to save kiosk PIN");
      err.data = errData;
      err.errors = errData?.errors;
      throw err;
    } catch (error) {
      if (error?.response?.data) {
        const d = error.response.data;
        const err = new Error(d?.data?.message || d?.message || "Failed to save kiosk PIN");
        err.data = d?.data || d;
        err.errors = d?.data?.errors || d?.errors;
        throw err;
      }
      throw error;
    }
  },

  //GET PROFILE
  getUserProfile: async () => {
      try {
        
        const response = await http.GET(`user_profile`);
          const resData = response;
          if(resData.code===200 && resData.data){
            UserService.storeProfile(resData.data);
            return resData.data;
        }
        return null;
      } catch (error) {
        // console.error('Error fetching user:', error);
        // throw error;
      }
    },
    getUserList: async (query={}) => {
      const queryString = new URLSearchParams(query).toString();
      try {
        
        const response = await http.GET(`users/by-role?${queryString}`);
        // console.log('response',response);
          if(response.code===200 && response.data){
            return response.data;
          }
        return null;
      } catch (error) {
        // console.error('Error fetching user:', error);
        throw error;
      }
    },
    getProfile:  () => {
      const storedProfile = localStorage.getItem('userProfile');
        if (storedProfile) {
          // If it exists, parse and return it
          try{
            // console.log('storedProfile',storedProfile);
            return JSON.parse(storedProfile);
          }catch(e){

          }
        }
    },
    //get user by id 
    getUserById: async (id) => {
      try {
        
        const response = await http.GET(`users/${id}`);
          if(response.code===200 && response.data){
            // UserService.storeProfile(resData.data);
            // console.log('resData.data',resData.data);
            return response.data;
        }
        return null;
      } catch (error) {
        // console.error('Error fetching user:', error);
        throw error;
      }
    },
    //Save user
    saveUser:async (data)=>{
      try {
        const response = await http.POST(`users`,data)
        // console.log('response',response);
            if((response.code===200 || response.code===201) && response.data){
              return response.data;
            }else{
              return response;
            }
      } catch (error) {
        console.error('Error fetching user:', error);
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        
        // throw error;
      }  
    },

     //Save user
     updateUser:async (userId,data)=>{
      try {
        const response = await http.PUT(`users/${userId}`,data);
          if((response.code===200 || response.code===201) && response.data){
            return response.data;
          }else{
            return response;
          }
      } catch (error) {
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        console.error('Error fetching user:', error);
        throw error;
      }  
    },
    updateUserProfile:async (userId,data)=>{
      try {
        const response = await http.PUT(`/update-profile/${userId}`,data);
          if((response.code===200 || response.code===201) && response.data){
            return response.data;
          }else{
            return response;
          }
      } catch (error) {
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        console.error('Error fetching user:', error);
        throw error;
      }  
    },
    updateBulkUser:async (body)=>{
      try {
        const response = await http.PUT(`users  `,body);
        if(response.status===200 && response.data){
          const resData = response.data;
          return resData;
        }else{
          return response;
        }
      } catch (error) {
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        console.error('Error fetching updateBulkUser:', error);
        throw error;
      }  
    },
    //Save user
    deleteUser:async (userId)=>{
      try {
        const response = await http.DELETE(`users/${userId}`);
        return response;
      } catch (error) {
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        console.error('Error fetching user:', error);
        throw error;
      }  
    },
   
    // STORE PROFILE
    storeProfile: (data) => {
      localStorage.setItem('userProfile',JSON.stringify(data));
    },
    //REMOVE PROFILE
    removeProfile: () => {
      // Remove the token from storage
      localStorage.removeItem('userProfile');
    },
    getUserStateList:async()=>{
      let defaultCountryCode='US';
     let response=await http.GET(`state-list/${defaultCountryCode}`);
     if (response.data && response.code===OK) {
      return response.data
     }
     else{
      return null;
     }
    },
    changePassword:async(data)=>{
      try {
      let response=await http.POST(`update-password`,data);
      return response;
    }
    catch(error){
      //
    }
    },
    
    updateDarkMode:async (userId,data) => {
      const response = await http.PUT(`update-theme/${userId}`,data);
      if(response.code===200 && response.data){
        const resData = response.data;
        return resData;      
      }
    },
    getUsersBasedOnRoles: wOrgIdMiddleware(async (url, role_name='') => {
      try {
        const response = await http.GET(`${url}role-based-user?role=${role_name}`);
        return response.data;
      } catch (error) {
          return null;
      }
    }),
    getUsersNotifications:async (query={}) => {
      try {
        const queryString = new URLSearchParams(query).toString();
        const response = await http.GET(`/get-user-notification?${queryString}`);
        return response.data;
      } catch (error) {
          return [];
      }
    },
    getUserName: wOrgIdMiddleware(async (url =null) => {
      try {
        const response = await http.GET(`${url}get-user`);
        return response.data;
      } catch (error) {
          return null;
      }
    }),
    
  };
  
  export default UserService;